<template>
  <div>
    <van-nav-bar
      style="background: #ffffff; color: #323233; font-weight: bold"
      fixed
      :title="transaction"
      left-arrow
      @click-left="onClickLeft"
    />
    <div id="aaa"></div>

    <van-cell-group title="影像中心" :border="false" style="margin-left: 10px">
      <van-cell
        icon="location-o"
        :value="currentAgent.name"
        style="border-bottom: 0.1px solid #f5f5f5"
      />
    </van-cell-group>
    <van-cell-group
      v-if="isHas"
      title="采购订单"
      :border="false"
      style="margin-left: 10px"
    >
      <van-cell
        icon="orders-o"
        :value="purchaseOrderNum"
        style="border-bottom: 0.1px solid #f5f5f5"
      />
    </van-cell-group>

    <van-cell-group title="出入库人员设置" :border="false" >
      <van-cell :title="checker"/>
    </van-cell-group>
    <van-cell-group title="备注" :border="false" style="margin-left: 10px">
      <van-cell style="border-bottom: 0.1px solid #f5f5f5" :value="remark" />
    </van-cell-group>

    <van-cell-group :title="transactionDetail" :border="false">
      <van-cell
        v-for="(item, index) in transactionDetailArr"
        :key="index"
        :class="{ ghbs: index % 2 == 1 }"
      >
        <van-row type="flex">
          <van-col span="3">型号:</van-col>
          <van-col span="11">{{ item.name }}</van-col>
          <van-col span="3" offset="2">品牌:</van-col>
          <van-col span="5">{{ item.bname }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between">
          <van-col span="3">数量:</van-col>
          <van-col span="11">{{ item.quantity }}</van-col>
          <van-col span="3" offset="2">单位:</van-col>
          <van-col span="5">{{ item.unit }}</van-col>
        </van-row>
        <van-row v-if="transaction == '采购入库'" type="flex" justify="space-between">
          <van-col span="6">有效范围:</van-col>
          <van-col span="6">{{ item.pd_date }}</van-col>
          <van-col span="2" offset="2">至</van-col>
          <van-col span="10">{{ item.exp_date }}</van-col>
        </van-row>
        <van-row v-if="transaction == '领用出库'" type="flex" justify="space-between">
          <van-col span="9">失效日期(出库数量):</van-col>
          <van-col span="15">{{item.out_detail}}</van-col>
        </van-row>
        <van-row type="flex">
          <van-col span="3">仓库:</van-col>
          <van-col span="11">{{ item.warehouse_name }}</van-col>
        </van-row>
      </van-cell>
    </van-cell-group>

    <van-cell-group
      v-if="transaction == '采购入库'"
      title="签收单"
      :border="false"
      style="margin-left: 10px"
    >
      <van-cell style="border-bottom: 0.1px solid #f5f5f5">
        <van-image
          width="5rem"
          height="5rem"
          fit="contain"
          :src="imagesrc"
          @click="clickImg"
        >
          <template v-slot:error>未上传签收单</template>
        </van-image>
      </van-cell>
    </van-cell-group>
    <van-cell-group
      v-if="transaction == '领用出库'"
      title="出库单"
      :border="false"
      style="margin-left: 10px"
    >
      <van-cell style="border-bottom: 0.1px solid #f5f5f5">
        <van-image
          width="5rem"
          height="5rem"
          fit="contain"
          :src="imagesrc"
          @click="clickImg"
        >
          <template v-slot:error>未上传出库单</template>
        </van-image>
      </van-cell>
    </van-cell-group>

<!--    <van-cell-group -->
<!--      v-if="isLock"-->
<!--      title="修改图片" -->
<!--      :border="false" -->
<!--      style="margin-left: 10px;"-->
<!--    >-->
<!--      <van-cell style="padding-left:18px">-->
<!--        <van-uploader v-model="fileList" multiple :max-count="1" :after-read="afterRead" />-->
<!--      </van-cell>-->
<!--    </van-cell-group>-->
<!--    <van-cell-group-->
<!--      v-if="isLock"-->
<!--    >-->
<!--      <van-cell>-->
<!--        <van-button-->
<!--          type="info"-->
<!--          style="font-size: 0.47333rem;background: #30cca8;border-radius: 50px;border: 0.02667rem solid #30cca8;font-weight:bold"-->
<!--          @click="tjxg"-->
<!--        >提交修改</van-button>-->
<!--      </van-cell>-->
<!--    </van-cell-group>-->

    <van-cell-group v-if="permission" title="操作">
      <van-cell>
        <van-row type="flex">
          <van-col span="10">
            <van-button
                round
                type="info"
                @click="tuihui"
            >退回</van-button>
          </van-col>
          <van-col span="2" ></van-col>
          <van-col span="10" >
            <van-button
                round
                type="info"
                @click="tijiao"
                v-bind:disabled="flag"
            >批准</van-button>
          </van-col>
        </van-row>
      </van-cell>
    </van-cell-group>

    <div
      v-show="bottom_tip"
      style="font-size: 10px; text-align: center; padding: 10px 10px"
    >
      ©2020 一脉阳光集团信息中心
    </div>
  </div>
</template>
<script>
import {
  NavBar,
  Tag,
  Image,
  DropdownMenu,
  DropdownItem,
  Col,
  Row,
  Panel,
  Divider,
  Button,
  Dialog,
  Toast,
  Uploader,
  ImagePreview,
} from "vant";
import { mapState, mapMutations } from "vuex";
// import axios from "axios";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Tag.name]: Tag,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Col.name]: Col,
    [Image.name]: Image,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [Panel.name]: Panel,
    [Divider.name]: Divider,
    [Row.name]: Row,
    [Uploader.name]: Uploader,
  },
  data() {
    return {
      fileList: [],
      bottom_tip: true,
      transaction: "",
      // isLock:"",
      isHas: "",
      purchaseOrderNum: "",
      remark: "",
      transactionDetail: "",
      transactionDetailArr: [],
      //当前选中的影像中心
      currentAgent: "",
      imagesrc: "",
      oldImage:"",
      newImage:"",
      permission:'',
      transcationId:'',
      checker:"申请人 -> 审核员",
      mainId:"",
      flag: false
    };
  },

  methods: {
    ...mapMutations(["changePermissionAgent", "changeDefaultAgentIndex"]),
    onClickLeft() {
      this.$router.push({
        name: "recordcheck",
        query: {
          ms: this.$route.query.ms,
          warehouse: this.$route.query.warehouse,
          type: this.$route.query.type,
          checkstatus:this.$route.query.checkstatus,
        },
      });
    },
    tjxg() {
      let that = this;
      Dialog.confirm({
        message: "确认修改",
      })
        .then(() => {
          let data = {
            main_id: that.mainId,
            old_url: that.oldImage,
            new_url: that.newImage
          };
          this.$http({
            method: "post",
            url: "/mobile/updateFile",
            data
          }).then(function (response) {
            if (response.state == 200) {
              Toast.success("修改成功");
              window.console.log(response);
              
              that.$router.push({
                name: "recordcheck",
                query: {
                  ms: that.$route.query.ms,
                  warehouse: that.$route.query.warehouse,
                  type: that.$route.query.type,
                },
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    tijiao(){
      let that = this;
      Dialog.confirm({
        message: "确认提交",
      })
      .then(() => {
        if (this.flag) return;
        this.flag = true;
        let data = {
          main_id: that.mainId,
          transcation_id: that.transcationId,
          auditor: localStorage.getItem("workcode")
        };
        let url = "";
        if (that.transcationId == '1'){
          url = "/mobile/warehousing";
        }else{
          url = "/mobile/stockOut";
        }
        that.$http({
          method: "post",
          url: url,
          data,
        }).then(function (response) {
          if (response.state == 200) {
            Toast.success("提交成功");
            that.$router.push("recordcheck");
          }
        });
      })
      .catch(() => {});
    },
    tuihui(){
      let that = this;
      Dialog.confirm({
        message: "确认退回",
      })
      .then(() => {
        let data = {
          main_id: that.mainId,
          auditor: localStorage.getItem("workcode")
        };
        that.$http({
          method: "post",
          url: "/mobile/returnCheck",
          data,
        }).then(function (response) {
          if (response.state == 200) {
            Toast.success("退回成功");
            that.$router.push("recordcheck");
          }
        });
      })
      .catch(() => {});
    },
    handleAjax(instance, id) {
      instance.$http
        .post("/mobile/checkDetailList", {
          mainid: id,
          mobile: localStorage.getItem("usermobile")
        })
        .then(function (response) {
          // window.console.log(response.record);
          // window.console.log(process.env.NODE_ENV);

          if (process.env.NODE_ENV == "development") {
            instance.imagesrc =
              "http://cm-test.rimag.com.cn" + response.record.main.img_url;
          } else {
            instance.imagesrc =
              "https://cm-api.rimag.com.cn" + response.record.main.img_url;
          }

          instance.oldImage = response.record.main.img_url;
          instance.mainId = response.record.main.id;
          instance.transaction = response.record.main.transcation_name;
          instance.permission = response.permission;
          instance.checker = response.checker;
          instance.transcationId = response.record.main.transcation_id;
          if (response.record.main.transcation_name == "采购入库") {
            instance.transactionDetail = "入库明细";
          } else {
            instance.transactionDetail = "出库明细";
          }
          instance.purchaseOrderNum = response.record.main.purchase_order_num;
          if (response.record.main.purchase_order_num == 0) {
            instance.isHas = false;
          } else {
            instance.isHas = true;
          }
          instance.remark = response.record.main.remark;
          instance.transactionDetailArr = response.record.detail;
        });
    },
    clickImg() {
      ImagePreview({
        images: [
          this.imagesrc
        ],
        closeable: true,
      });
    },
  },
  computed: {
    ...mapState(["permissionAgent", "defaultAgentIndex"]),
  },

  created() {
    if (this.permissionAgent) {
      let _this = this;
      this.currentAgent = this.permissionAgent.find(function (item) {
        return item.id == _this.defaultAgentIndex;
      });
      this.handleAjax(this, this.$route.query.id);
    } else {
      let _this = this;
      this.$http
        .post("/mobile/rimsAgentList", {
          username: localStorage.getItem("usermobile"),
        })
        .then(function (response) {
          _this.changePermissionAgent(response.rimsAgent);
          if(!localStorage.getItem("defaultAgentIndex")){
            _this.changeDefaultAgentIndex(response.rimsAgent[0].id);
          }
          _this.currentAgent = _this.permissionAgent.find(function (item) {
            return item.id == _this.defaultAgentIndex;
          });
          _this.handleAjax(_this, _this.$route.query.id);
        });
    }
  },
};
</script>
<style scoped lang="less">
.van-nav-bar__title {
  font-weight: 800;
  color: white;
}
.van-nav-bar .van-icon {
  color: white;
}
.van-nav-bar .van-icon {
  color: white;
}

.haha .van-cell {
  line-height: 1.2rem !important;
  border: 1px solid #dadae4;
  margin-bottom: 10px;
}
.ha {
  border-bottom: 0.2px solid #dcdcdc;
  font-weight: bold;
}
.haha .selecteddetail {
  /*background: #F4A460;*/
  background: #fafafa;
  border: 1px solid #dadae4;
}
.van-tag {
  margin-left: 2%;
}
.selected {
  background-color: #e2f3e2 !important;
  color: #32ca72 !important;
}
.van-button {
  width: 100%;
}
#aaa {
  width: 100vw;
  height: 46px;
}
.van-nav-bar__title {
  font-weight: 800;
  color: #323233;
}
.van-nav-bar .van-icon {
  color: rgba(0, 0, 0, 0.7);
}
.van-tag--default {
  background-color: #f7f8fa;
}
.choiceWarhouse .van-tag {
  padding: 0.6em 1.5em !important;
  /*font-weight: bold;*/
  font-size: 0.4rem;
  margin: 0.2em;
  color: #323233;
  border-radius: 10px;
}
.van-cell-group__title {
  color: #323233 !important;
  font-weight: bold;
  font-size: 0.38rem;
  background-color: #f7f8fa;
}
.van-cell {
  color: #969799 !important;
}
.van-tag--danger.van-tag--plain {
  color: rgb(131, 134, 131);
}
.upload-img {
  display: flex;
  flex-wrap: wrap;
}
.img-box {
  width: 88px;
  height: 88px;
  margin-right: 8px;
  margin-bottom: 8px;
}
.image {
  width: 88px;
  height: 88px;
}
// .ghbs{
//   background-color: rgb(249,249,249)
// }
</style>